import { Modal } from 'reactstrap';
import styled from 'styled-components';

export const StyledModalCancel = styled(Modal)``;
